import { render } from "./SongDetail.vue?vue&type=template&id=34060c9a&scoped=true"
import script from "./SongDetail.vue?vue&type=script&lang=js"
export * from "./SongDetail.vue?vue&type=script&lang=js"

import "./songs.scss?vue&type=style&index=0&id=34060c9a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34060c9a"]])

export default __exports__